import HubriseConfig from './HubriseConfig.view';

export default HubriseConfig;
